import React, { useState, useRef, useEffect, useContext } from 'react';
import './SubtitlesContextMenu.css';
import { AppContext } from '../../appContext';

export const ContextMenu = ({onComment, onMark, onEdit, onSendFolder, onSendDesktop, position, boundingElement}: {
    onComment: ()=>void,
    onEdit: ()=>void,
    onMark: (type: string)=>void,
    onSendFolder: ()=>void,
    onSendDesktop: ()=>void,
    position: {top: number, left: number}
    boundingElement: HTMLElement;
})=>{
    const { translate } = useContext(AppContext);
    const [side, setSide] = useState('');
    const menuRef = useRef<HTMLDivElement>(null);
    useEffect(()=>{
        if (!menuRef.current){
            return;
        }
        const bounding = boundingElement.getBoundingClientRect();
        //menuRef.current.parentElement.parentElement.parentElement.parentElement.getBoundingClientRect(); //window.document.documentElement.getBoundingClientRect();
        const menu = menuRef.current.getBoundingClientRect();
        //console.log(bounding, menu);
        let _side = '';
        if (bounding.right < position.left+menu.width){
            _side += 'r';
        } else //if (bounding.left > position.left - menu.width)
        {
            _side += 'l';
        }

        if (bounding.bottom > position.top+menu.height){
            _side += 't';
        } else {
            _side += 'b';
        }
       setSide(_side);
    }, [menuRef.current, position]);
    return <div ref={menuRef} className={`subtitlesContextMenu subtitlesContextMenu--main ${!side ? "subtitlesContextMenu--hide" : ""} ${"subtitlesContextMenu--"+side}`}>
        <div className="subtitlesContextMenu_group">
            <div className="button subtitlesContextMenu_button subtitlesContextMenu_icon--edit" onClick={onEdit}>{translate('subtitles_context_edit')}</div>
            <div className="button subtitlesContextMenu_button subtitlesContextMenu_icon--message" onClick={onComment}>{translate('subtitles_context_comment')}</div>
            <div className="button subtitlesContextMenu_button subtitlesContextMenu_buttonMenu subtitlesContextMenu_icon--send">{translate('subtitles_context_send_to')}
                <div className="subtitlesContextMenu">
                    <div className="button subtitlesContextMenu_button subtitlesContextMenu_icon--folder" onClick={onSendFolder}>{translate('subtitles_context_folder')}</div>
                    <div className="button subtitlesContextMenu_button subtitlesContextMenu_icon--desktop" onClick={onSendDesktop}>{translate('subtitles_context_desktop')}</div>
                </div>
            </div>
        </div>
        <div className="subtitlesContextMenu_group">
            <div className="button subtitlesContextMenu_button subtitlesContextMenu_icon--target" onClick={()=>onMark('attention')}>{translate('subtitles_context_attention')}</div>
        </div>
    </div>
}